import formsSelect from "./_select.js";
import formsInputDate from "./_inputDate.js";
import formsZip from "./_zip.js";

const components = () => {
    formsSelect();
    formsInputDate();
    formsZip();
};

export default components;
